import React, { useCallback, useState } from 'react';

import type { MessageTemplate } from '@this/components/arrangement/virtual_counter/types';
import { InputLabel } from '@this/shared/ui/inputs/form_control';
import { AutocompleteSelect } from '@this/shared/ui/inputs/autocomplete';
import { Flex } from '@this/shared/ui/layout/flex';
import { Link } from '@this/shared/ui/navigations/link';

type Props = {
  messageTemplates: MessageTemplate[];
  onApply: (content: string) => void;
};

export const MessageBulkSendTemplateSelector = ({ messageTemplates, onApply }: Props) => {
  const [selectedTemplate, setSelectedTemplate] = useState<MessageTemplate | null>(null);

  const handleApply = useCallback(() => {
    if (!selectedTemplate) {
      return;
    }
    onApply(selectedTemplate.content ?? '');
  }, [selectedTemplate, onApply]);

  return (
    <Flex alignItems="center" gap="8px">
      <InputLabel>テンプレート</InputLabel>
      <div style={{ width: '300px' }} data-testid="message-bulk-send-template-select">
        <AutocompleteSelect
          size="small"
          placeholder="テンプレートを選択"
          options={messageTemplates}
          getOptionLabel={template => template.title ?? ''}
          onChange={(e, template) => setSelectedTemplate(template)}
          disableClearable
          fullWidth
        />
      </div>
      <Link data-testid="message-bulk-send-template-apply" onClick={handleApply} disabled={!selectedTemplate}>
        適用
      </Link>
    </Flex>
  );
};
